import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import {
  LINK_REGEX,
  SLUG_REGEX,
} from '@conversed/shared/src/central/constants/regex';
import type { CreateLinkReqDTO } from '@conversed/shared/src/central/dto/link.dto';
import type React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';

type Props = {
  linkData?: Partial<CreateLinkReqDTO>;
  onSubmit: (data: CreateLinkReqDTO) => void;
  isAllowedToEditShortLink?: boolean;
};

export const LinkDataModal: React.FC<Props> = ({
  linkData,
  onSubmit,
  isAllowedToEditShortLink,
}) => {
  const { t } = useTranslation();

  const { handleSubmit, control } = useForm<CreateLinkReqDTO>({
    defaultValues: linkData,
    shouldUseNativeValidation: true,
  });

  const { hideModal } = useModal();

  const hideAndSubmit = (data: CreateLinkReqDTO) => {
    onSubmit(data);
    hideModal();
  };

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='shortLink'
              placeholder={t('link-settings.add-link.form.short-link')}
              label={t('link-settings.add-link.form.short-link')}
              id='shortLink'
              control={control}
              options={{
                minLength: 2,
                maxLength: 16,
                disabled: !isAllowedToEditShortLink,
                required: t('general.validation.required'),
                pattern: {
                  value: SLUG_REGEX,
                  message: t('general.validation.invalid-format'),
                },
              }}
            />
          </div>

          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='originalLink'
              placeholder={t('link-settings.add-link.form.original-link')}
              label={t('link-settings.add-link.form.original-link')}
              id='originalLink'
              control={control}
              options={{
                required: t('general.validation.required'),
                pattern: {
                  value: LINK_REGEX,
                  message: t('general.validation.invalid-format'),
                },
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default LinkDataModal;
